<template>
    <el-dialog
      v-model="show"
      :width="
        $vuetify.display.width <= 1400
          ? 800
          : $vuetify.display.width <= 1600
          ? 1000
          : $vuetify.display.width <= 2000
          ? 1400
          : $vuetify.display.width <= 2456
          ? '75%'
          : ''
      "
      :fullscreen="$vuetify.display.width <= 800 ? true : false"
      class="public-style"
      destroy-on-close
      align-center
      @close="close"
    >
      <h5 v-if="createdAtDate">
        Session Logs Preview — Upload date: {{ createdAtDate }}
        <span v-if="customerName"> ({{ customerName }})</span>
      </h5>
  
      <el-alert
        v-if="previewTotalCount > previewCount"
        type="info"
        class="alert-style mb-2"
        show-icon
        :closable="false"
      >
        <p class="ma-0 text-white">
          Showing preview of {{ previewCount }} of {{ previewTotalCount }} records
          (first 50 and last 50 by ID).
        </p>
      </el-alert>
  
      <div class="popUpTable">
        <div
          v-loading="loading"
          class="custom-table-design"
        >
          <el-table
            :data="paginatedData"
            stripe
            :fit="true"
            :height="$vuetify.display.width <= 630 ? '400px' : '500px'"
            class="my-2 data-table"
            scrollbar-always-on: false
          >
            <el-table-column label="ID" prop="id" sortable width="80" />
            <el-table-column label="Register ID" prop="register_id" sortable />
            <el-table-column label="Site Title" prop="site_title" sortable />
            <el-table-column label="Charger ID" prop="charger_id" sortable />
            <el-table-column label="Port" prop="port" sortable width="80" />
            <el-table-column label="Start Time" prop="start_time" sortable>
              <template #default="scope">
                {{ scope.row.start_time ? scope.row.start_time.replace('T', ' ') : '' }}
              </template>
            </el-table-column>
            <el-table-column label="End Time" prop="end_time" sortable>
              <template #default="scope">
                {{ scope.row.end_time ? scope.row.end_time.replace('T', ' ') : '' }}
              </template>
            </el-table-column>
            <el-table-column label="Usage kWh" prop="usage_kWh" sortable />
            <el-table-column label="Description" prop="description" sortable />
          </el-table>
        </div>
  
        <div v-if="totalItems > perPageCount" class="custom-pagination">
          <el-row class="row-bg" justify="center">
            <el-col
              :span="24"
              class="d-flex align-items-center justify-content-center"
            >
              <el-pagination
                small
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="perPageCount"
                v-model:current-page="currentPage"
                class="my-4"
              />
            </el-col>
            <el-col
              :span="24"
              class="d-flex align-items-center justify-content-center"
            >
              <span class="text-white">
                {{ rangeStart.toLocaleString() }}-{{ rangeEnd.toLocaleString() }}
                of {{ totalItems.toLocaleString() }} preview records
              </span>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </template>
  
  <script>
  export default {
    props: {
      open_modal: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      tableData: {
        type: Array,
        default: () => [],
      },
      previewTotalCount: {
        type: Number,
        default: 0,
      },
      previewCount: {
        type: Number,
        default: 0,
      },
      createdAtDate: {
        type: String,
        default: null,
      },
      customerName: {
        type: String,
        default: null,
      },
    },
    computed: {
      totalItems() {
        return this.tableData.length;
      },
      paginatedData() {
        const start = (this.currentPage - 1) * this.perPageCount;
        const end = this.currentPage * this.perPageCount;
        return this.tableData.slice(start, end);
      },
      rangeStart() {
        if (this.totalItems === 0) {
          return 0;
        }
        return (this.currentPage - 1) * this.perPageCount + 1;
      },
      rangeEnd() {
        return Math.min(this.currentPage * this.perPageCount, this.totalItems);
      },
    },
    data() {
      return {
        show: this.open_modal,
        currentPage: 1,
        perPageCount: 50,
      };
    },
    watch: {
      open_modal(newVal) {
        this.show = newVal;
        if (newVal) {
          this.currentPage = 1;
        }
      },
      tableData() {
        this.currentPage = 1;
      },
    },
    methods: {
      close() {
        this.show = false;
        this.currentPage = 1;
        this.$emit("close_modal", false);
      },
    },
  };
  </script>
  
  <style scoped>
  h5 {
    color: #ffffff;
  }
  
  .el-dialog__body {
    padding: 30px 10px;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }
  
  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
  </style>